import { Button } from "@progress/kendo-react-buttons";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Field } from "@progress/kendo-react-form";
import { Hint } from "@progress/kendo-react-labels";
import { PropsWithChildren, useState } from "react";
import { requiredCheckboxValidator } from "../../validators";
import FormCheckbox from "../form/FormCheckBox";

interface ISubmitDisclaimerProps {
  canSubmit: boolean;
  hasCredit: boolean;
  title?: string;
  tandcDocument?: string;
  fieldName: string;
  handleAgree: () => void;
}

export const SubmitDisclaimer = ({
  canSubmit,
  hasCredit,
  title,
  tandcDocument,
  fieldName,
  handleAgree,
  children,
}: PropsWithChildren<ISubmitDisclaimerProps>) => {
  const [showDialog, setShowDialog] = useState(false);

  const onClickLink = (e: any) => {
    e.preventDefault();
    setShowDialog(!showDialog);
  };

  const onCancel = () => {
    setShowDialog(false);
  };

  const onAgree = () => {
    onCancel();
    handleAgree();
  };

  return (
    <>
      {canSubmit && (
        <Field name={fieldName} component={FormCheckbox} validator={requiredCheckboxValidator}>
          <label className="k-checkbox-label" htmlFor={fieldName}>
            I have read and accept the{" "}
            <a href="#" style={{ fontWeight: "bold" }} onClick={onClickLink}>
              disclaimers
            </a>{" "}
            and the{" "}
            <a
              href={tandcDocument ?? "/examples/SampleTermsAndConditions.pdf"}
              style={{ fontWeight: "bold" }}
              target="_blank"
            >
              Terms and Conditions
            </a>
          </label>
        </Field>
      )}

      {!canSubmit && (
        <Hint style={{ fontWeight: "bold" }}>
          This quote is saved but cannot be submitted. If you would like to submit this quote for
          approval, please contact Risk Canopy to enable{" "}
          {!hasCredit ? `the company's credit terms` : `your user permissions`}.
        </Hint>
      )}

      {showDialog && (
        <Dialog title={title ?? "Disclaimers"} onClose={onCancel} width={"60%"}>
          {children}

          <div
            style={{
              display: "flex",
              alignContent: "center",
              justifyContent: "center",
              gap: 10,
              marginTop: 5,
            }}
          >
            <Button size="small" onClick={onCancel}>
              Cancel
            </Button>
            <Button size="small" themeColor="primary" onClick={onAgree}>
              Agree
            </Button>
          </div>
        </Dialog>
      )}
    </>
  );
};
